import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { PasswordTemplate } from "components/entrance/signup";
import {
  setPassword,
  setPasswordConfirm,
} from "redux/slices/signup/signupSlice";

const SignupPassword = () => {
  const dispatch = useDispatch();
  const { password, passwordConfirm } = useSelector((state) => state.signup);
  const navigate = useNavigate();

  const handleChangePassword = (e) => {
    dispatch(setPassword(e.target.value));
  };
  const handleChangePasswordConfirm = (e) => {
    dispatch(setPasswordConfirm(e.target.value));
  };

  return (
    <PasswordTemplate
      title={`로그인을 위해\n비밀번호를 등록해주세요`}
      inputValue={[passwordConfirm, password]}
      inputValueChange={[handleChangePasswordConfirm, handleChangePassword]}
      buttonOnClick={() => navigate("/entrance/signup/info")}
      onClickBack={() => navigate("/entrance/signup", { replace: true })}
    />
  );
};
export default SignupPassword;
